import React, { useState, useEffect } from 'react';
import { CustomHeader } from '../../../components/headers/CustomHeader';

interface Props {
  user: { name: string; };
  selectedyear: number | null;
  setSelectedYear: (year: number) => void;
}

const UserAccountOverview = ({ user, selectedyear, setSelectedYear }: Props) => {
  const years = [
    { id: 1, year: 2024 },
    { id: 2, year: 2025 },
    { id: 3, year: 2026 },
    { id: 4, year: 2027 },
    { id: 5, year: 2028 },
  ];

  return (
    <div className="flex justify-between items-center">
      <CustomHeader title={`Overview - Welcome, ${user.name}`} />

      <div className="flex items-center space-x-4">
        <select
          value={selectedyear ?? ''}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="border rounded px-4 py-2 text-xs"
        >
          <option value="" disabled>
            Select Production Year
          </option>
          <option value={0}>
            All
          </option>
          {years.map((year) => (
            <option key={year.id} value={year.year}>
              {year.year}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default UserAccountOverview;
